import { NavLink } from "react-router-dom";

type Props = {
  title: string;
  appId: string;
  body: string;
};

export function ComingSoonTabPanel({ title, appId, body }: Props) {
  return (
    <div className="card card--gov card--elevated coming-soon-tab" aria-live="polite">
      <h2 className="card__title card__title--gov">{title}</h2>
      <p className="tab-intro">{body}</p>
      <NavLink to={`/applications/${appId}/overview`} className="btn btn--primary btn--tg">
        Back to Overview
      </NavLink>
    </div>
  );
}
